export default [ 
	{ path: '/', component: () => import('@/components/Home.vue'), alias: '/home' },
	{ path: '/meet-aaron', component: () => import('@/components/About.vue') },
	{ path: '/platform', component: () => import('@/components/Platform.vue') },
	{ path: '/leadership', component: () => import('@/components/Leadership.vue') },
	{ path: '/leadership/:volunter_pattern', component: () => import('@/components/Leadership.vue') },
	{ path: '/donate', name: 'donate', component: () => import('@/components/Donate.vue') },
	{ path: '/vote', component: () => import('@/components/Vote.vue') },
	{ path: '/event', component: () => import('@/components/Event.vue') },
	{ path: '/contact', component: () => import('@/components/Contact.vue') },
	{ path: '/watch', component: () => import('@/components/Watch.vue') },
 ];